import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { Elements } from 'react-stripe-elements';
import StripeForm from './Form';
import './AddCardModal.css';

const AddCardModal = props => {
    const { modal, toggle } = props;
    return (
        <div>
            <Modal isOpen={modal} toggle={toggle} className="inviteFriendsModal">
                <ModalHeader toggle={toggle}>Add card</ModalHeader>
                <ModalBody>
                    <Elements>
                        <StripeForm toggle={toggle} />
                    </Elements>
                </ModalBody>
            </Modal>
        </div>
    );
};

export default AddCardModal;
